export const emptyString = (str) =>
  !Boolean(str) || str === '' || str.length === 0;
